import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { mainColor } from '../../constants';
import TablePagination from "@mui/material/TablePagination";
import styled from '@emotion/styled';
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.common.black,
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        },
    }));

export default function EmpsTable({rows, header}) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5); 
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
  return (
    <Paper>
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                {header.map(i=><StyledTableCell key={i} align='center'>{i}</StyledTableCell>)}
            </TableRow>
            </TableHead>
            <TableBody>
                    {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row,i)=>(
                <TableRow key={row[2]+i}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                        <TableCell>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <img src={row[0]||require('../../assets/Avatar.png')} 
                                width={50} height={50} 
                                style={{
                                    borderRadius:"50%",
                                }}  
                                />

                            </div>
                        </TableCell>

                        <TableCell align='center'  >{row[1]}</TableCell>
                        <TableCell align='center' >{row[2]}</TableCell>
                </TableRow>
                    ))}
            
            </TableBody>
        </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[5]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </Paper>
  );
}